module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Gd-Ha-Ib-Jb.4c359917.png";